<template>
    <v-card elevation="2" shaped class="ma-1">
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Paramètres de la GED</v-toolbar-title>
      </v-toolbar>

      <div>

        <v-tabs align="start" background-color="blue lighten-5" v-model="tab">
          <v-tab> requete </v-tab>
          <v-tab> Paramètres de ciblage dossier </v-tab>
          
          <v-tabs-items v-model="tab" class="pl-4">

            <v-tab-item>


              <v-tabs align="start" background-color="blue lighten-5 ma-3" v-model="tab2">
          <v-tab> filtre </v-tab>
          <v-tab> champs </v-tab>
          
          <v-tabs-items v-model="tab2" class="pl-4">
              <v-tab-item>
                  <Filtre
                    :filtre="displays.filter"
                    :table="module.table"
                    @recepVal="(data) => {displays.filter = data; $emit('recepVal',displays); }"
                  />
              </v-tab-item>

              <v-tab-item>
                <Fields
                  :table="module.table"
                  :champs="displays.params.champs"
                  :filter="displays.filter"
                  :modalKey="modalKey"
                  :page="page"
                  @recepVal="changeChamps"
                  />
              </v-tab-item>
          </v-tabs-items>
          </v-tabs>




            </v-tab-item>

            <v-tab-item>

              <TextField 
              :item="{name:'Dossier racine',value:'root',defaultprops:{show:true,persistenthint:true,description:'chemin ou la GED va trouver les dossiers (Il peut être vide)'}}" 
              :keyup="(item,value) => { displays.params.root = value; $emit('recepVal',displays);}"
              :valField="displays.params.root" /> 

              <Select
              :item="{name: 'Type de navigation',value: 'navigation',liste: [{ text: 'libre', value: 'free' },{ text: 'ciblé à un dossier spécifique', value: 'folder' }],
              defaultprops:{ show: true}}"
              :change="(item,value,select) => { displays.params.navigation = value[select]; $emit('recepVal',displays); }"
              :valField="displays.params.navigation"
            /> 

            <div  v-if="displays.params.navigation=='folder'">
            <ArrayTable 
                :item="{otherparams:{
                    arrayTable:[
                        {type:'',key:'name',name:'Nom du dossier'}]}
                ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter un dossier dès ouverture'}}"
                :valField="displays.params.foldersonopen"
                :change="(item,value) => {displays.params.foldersonopen = value; $emit('recepVal',displays);}"
                />
                  <v-row>
                    <v-col class="grey lighten-3 rounded pa-3 ma-3">
                          <div class="text-h6">Ciblage du dossier</div>
                        Le dossier sera automatiquement créé dès la première ouverture de la GED
                        <Select
                          :item="{name: 'table ciblée',value: 'navigation',liste: listTables,
                          defaultprops:{ show: true}}"
                          :change="(item,value,select) => { displays.params.folderID.table = value[select]; getFieldsforTargetTable(); }"
                          :valField="displays.params.folderID.table"
                        />    
                        <TextField 
                        :item="{name:'id ciblé',value:'id',defaultprops:{show:true,description:'(vous pouvez mettre la variable d\'envirronnement [[line||mon_as]]) qui provient de la requete du module'}}" 
                        :keyup="(item,value) => { displays.params.folderID.id = value; $emit('recepVal',displays);}"
                        :valField="displays.params.folderID.id" /> 

                        <TextField 
                        :item="{name:'sous dossier',value:'sousdossier',defaultprops:{show:true,description:'(vous pouvez mettre la variable d\'envirronnement [[line||mon_as]]) qui provient de la requete du module'}}" 
                        :keyup="(item,value) => { displays.params.folderID.sousdossier = value; $emit('recepVal',displays);}"
                        :valField="displays.params.folderID.sousdossier" /> 

                        <v-switch
                          class="mt-2"
                          inset
                          :label="`Envoyer un document sans charger le dossier préalablement`"
                          v-model="displays.params.folderID.loadonly"
                          :true-value="true"
                          :false-value="false"
                          @change="$emit('recepVal', displays)"
                        ></v-switch>

                        Vous pouvez rajouter un intitulé supplémentaire après l'identifiant du dossier (au moment de sa création, éléments séparés automatiquement par des espaces)
                        <ArrayTable 
                          :item="{otherparams:{
                              arrayTable:[
                                  {type:'',key:'name',name:'Intitulé',description:'Vous pouvez insérer la variable d\'envirronnement [[line||mon_as]]'}]}
                          ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'ajouter un intitulé sur le nom du dossier'}}"
                          :valField="displays.params.folderName"
                          :change="(item,value) => {displays.params.folderName = value; $emit('recepVal',displays);}"
                          />


                    </v-col>
                    <v-col class="grey lighten-3 rounded pa-3 ma-3">
                      <div class="text-h6">Dossier parent ?</div>
                        Mentionnez si le dossier ciblé appartient à un dossier ciblé parent
                        (Dans le cas ou le dossier parent n'est pas créé, mentionner le module permettant l'affichage de ce dossier)
                          <Select
                          :item="{name: 'Choix du module GED',value: 'gedmodule',liste: listGedModule,
                          defaultprops:{ show: true, column: false,clearable:true }}"
                          :change="changeGedMod"
                          :valField="displays.params.isChildFolder.gedmodule"
                          />    
                        <ArrayTable 
                          :item="{otherparams:{
                              arrayTable:[
                                  {type:'',key:'key',name:'nom de la clé',description:''},{type:'',key:'value',name:'valeur',description:'variable environnement line possible'}]}
                          ,defaultprops:{show:true,tableDraggable:false,tableDel:true,hideFooter:true,hidesearch:true,addTitle:'+ params pour la GED parentes'}}"
                          :valField="displays.params.isChildFolder.paramgedmodule"
                          :change="(item,value) => {displays.params.isChildFolder.paramgedmodule = value; $emit('recepVal',displays);}"
                          /> 
                        <Select
                          :item="{name: 'Table parente ciblée',value: 'table',liste: listTables,
                          defaultprops:{ show: true,clearable:true}}"
                          :change="changeGedMod"
                          :valField="displays.params.isChildFolder.table"
                        />
                        <TextField 
                        :item="{name:'id ciblé',value:'id',defaultprops:{show:true,description:'(variable d\'envirronnement possible : ex:[[line||mon_as]])'}}" 
                        :keyup="(item,value) => { displays.params.isChildFolder.id = value; $emit('recepVal',displays);}"
                        :valField="displays.params.isChildFolder.id" /> 
                    </v-col>
                  </v-row>                          
                </div>

                Champ de sauvegarde pour le permalien :
                <Select
                :key="FieldsforTargetTable.length"
                :item="{name: 'Champ sujet à la sauvegarde du permalien',value: 'table',liste: FieldsforTargetTable,
                defaultprops:{ show: true,clearable:true}}"
                :change="(item,value) => { displays.params.fieldpermalink = value.value}"
                :valField="displays.params.fieldpermalink"
                />

                <v-switch
                  class="mt-4"
                  inset
                  :label="`Générer les liens Dropbox pour tous les éléments`"
                  v-model="displays.params.usesharedlink"
                  :true-value="true"
                  :false-value="false"
                  @change="$emit('recepVal', displays)"
                ></v-switch>

                <v-switch
                  class="mt-1"
                  inset
                  :label="`Ne pas charger automatiquement les elements du dossier`"
                  v-model="displays.params.manualLoad"
                  :true-value="true"
                  :false-value="false"
                  @change="$emit('recepVal', displays)"
                ></v-switch>

            </v-tab-item>

          </v-tabs-items>
        </v-tabs>
    </div>
    </v-card>
  </template>
  
  
  
  <script>
    import { admin } from '../mixins'; 
  export default {
    name: "BibliothequeModule",

    mixins : [admin],
  
    data: function () {
      return {

        displays: this.module.displays,
        tab : '',
        tab2 : '',
        listTables : [],
        listFields : [],
        listGedModule : [],
        FieldsforTargetTable : []
      };
    },
  
    watch: {


  },
  
    methods: {

      initLoadOnly() {
        if (!this.displays || !this.displays.params || !this.displays.params.folderID) return;
        if (!Object.prototype.hasOwnProperty.call(this.displays.params.folderID, 'loadonly')) {
          this.$set(this.displays.params.folderID, 'loadonly', false);
        }
      },

      changeChamps(data) {
        this.displays.params.champs = data;
        this.listFields = [];
        data.forEach((field) => {
          this.listFields.push(field.as)
        })
        this.$emit('recepVal',this.displays);
      },

      changeGedMod(item,value) {
        this.displays.params.isChildFolder[item.value] = value?.value ?? "";
        this.$emit("recepVal", this.displays);        
      },

      getFieldsforTargetTable() {
        this.FieldsforTargetTable = []
        this.getListField({filter:{table:this.displays.params.folderID.table}}).then((datas) => {
            datas.forEach((field) =>  {
                this.FieldsforTargetTable.push({"text":field.field+" ("+field.cle+")","value":field.cle});
                    })          
        })
      }
  
    },
  
    mounted() {
      this.initLoadOnly()
      this.API({type:'get', url:'engine/getlisttable'}).then((resp) => {
                    resp.data.forEach((table) => {
                        this.listTables.push({text:table,value:table})
                    })
                    
                })
        //permet de lister les modules GED pour le parent
        this.API({type:'post', url:'/engine/module/list',params:{type:'ged'}}).then((resp) => {                                             

                  resp.data.forEach((ged) => {
                  if(ged.id!=this.module.id)this.listGedModule.push({text:ged.name,value:ged.id,listfolder:ged.displays.params.foldersonopen});
                  })
          })

        if(this.displays.params.folderID.table!='') this.getFieldsforTargetTable()
    },
  };
  </script>
  
  
